(function ($) {
    let $fn = $(".part_slider");

    if ($fn.length) {
        $fn.each(function () {
            $(this).init_slider();
        })
    }
})(jQuery);